// import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';



@Component({
    selector: 'app-loading-button',
    standalone: true,
    imports: [CommonModule,
        FontAwesomeModule,],
    templateUrl: './loading-button.component.html',
    styleUrl: './loading-button.component.scss'
})
export class LoadingButtonComponent {

  @Input() label = 'Submit';
   @Input() isLoading = false;
   @Input() isDisabled = false;
   @Input() activeClass = 'active-button';
   @Input() inactiveClass = 'inactive-button';
   @Output() clicked = new EventEmitter<void>();
   @Input() customClass = '';

  
   faSpinner: IconDefinition = faSpinner;
  
   onClick() {
    if (!this.isDisabled && !this.isLoading) {
    this.clicked.emit();
    }
   }
  
}
